import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import * as Sentry from "@sentry/react";
// import Home from './.tsx'

// @ts-ignore
import { registerSW } from "virtual:pwa-register";
registerSW();

if(import.meta.env.MODE !== "development"){
    Sentry.init({
        dsn: "https://ed80d8c74045170b6a26987065e87035@o1063702.ingest.us.sentry.io/4509005030096896",
    });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
